module.exports = __webpack_public_path__ + "images/旅悦好物全景_01.jpg?v=7ed01550";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/lvyue3/旅悦好物全景_01.jpg
 ** module id = 127
 ** module chunks = 1 2
 **/